$(document).ready(function() {
    $('.collection-intro-text.by-nav-filter').hide();
    $('.collection-nav-filter-image').hide();
    $('.wood-fabric-finishes').hide();

    setTimeout(function() {
        var nav_filter = $('.individual_tags.active').attr('data-value');

        if (nav_filter && $(`.collection-intro-text[nav-data-filter="${nav_filter}"]`).length) {
            $(`.collection-intro-text[nav-data-filter="${nav_filter}"]`).show();
        }
        if (nav_filter && $(`.collection-nav-filter-image[nav-data-filter="${nav_filter}"]`).length) {
            $(`.collection-nav-filter-image[nav-data-filter="${nav_filter}"]`).show();
        }
        $('.wood-fabric-finishes').each(function() {
            if (nav_filter && $(this).attr('nav-data-filter').includes(nav_filter)) {
                $(this).show();
            }
        });
    }, 2500);

    $('.ProductItem__addtional-option').each(function() {
        $(this).on('click', function() {
            $(this).closest('.ProductItem__ColorSwatchList').toggleClass('active');
        });
    });
});

var get_width = $(window).width();
if(get_width < 768 ){
    $(document).on("click",".custom_tags_wrappper_filters_mobile_sturctre .individual_tags.init",function() {
        $(this).find('ul').toggle();
    });
}

$('.individual_tags li').each(function() {
    $(this).on('click', function() {
        $(this).parents('.individual_tags').find('.parent_name_li').text($(this).html());
        $("ul.select_box_tags.list-unstyled").hide();
        $(this).parent().toggle();

        $('.collection-intro-text.by-nav-filter').hide();
        $('.collection-nav-filter-image').hide();
        $('.wood-fabric-finishes').hide();
        setTimeout(function() {
            var nav_filter = $('.individual_tags.active').attr('data-value');

            if (nav_filter && $(`.collection-intro-text[nav-data-filter="${nav_filter}"]`).length) {
                $(`.collection-intro-text[nav-data-filter="${nav_filter}"]`).show();
            }
            if (nav_filter && $(`.collection-nav-filter-image[nav-data-filter="${nav_filter}"]`).length) {
                $(`.collection-nav-filter-image[nav-data-filter="${nav_filter}"]`).show();
            }
            $('.wood-fabric-finishes').each(function() {
                if (nav_filter && $(this).attr('nav-data-filter').includes(nav_filter)) {
                    $(this).show();
                }
            });
        }, 2500);
    });
});

$('.custom_tags_inner .filter_trigger_custom').each(function() {
    $(this).on('click', function() {
        var check_exist = $(this).hasClass('active');
        var check_element_same = $(this).attr('data-value');
        if(check_exist == false){
            $(".individual_tags").removeClass('active');
            $(this).addClass('active');
            $('.individual_tags[data-value="'+check_element_same+'"]').addClass('active');
        } else {
            $(".individual_tags").removeClass('active');
            $('.individual_tags[data-value="'+check_element_same+'"]').removeClass('active');
        }
        var get_tag = $(this).attr('data-value');
        $('html, body').animate({
            scrollTop: $(".CollectionInner__Products").offset().top-100},
        1000);
        $(".CollectionInner__Sidebar .CollectionFilters li.Linklist__Item button.Link.Link--primary.Text--subdued[data-tag="+get_tag+"]").trigger('click');

        $('.collection-intro-text.by-nav-filter').hide();
        $('.collection-nav-filter-image').hide();
        $('.wood-fabric-finishes').hide();
        setTimeout(function() {
            var nav_filter = $('.individual_tags.active').attr('data-value');

            if (nav_filter && $(`.collection-intro-text[nav-data-filter="${nav_filter}"]`).length) {
                $(`.collection-intro-text[nav-data-filter="${nav_filter}"]`).show();
            }
            if (nav_filter && $(`.collection-nav-filter-image[nav-data-filter="${nav_filter}"]`).length) {
                $(`.collection-nav-filter-image[nav-data-filter="${nav_filter}"]`).show();
            }
            $('.wood-fabric-finishes').each(function() {
                if (nav_filter && $(this).attr('nav-data-filter').includes(nav_filter)) {
                    $(this).show();
                }
            });
        }, 2500);
    });
});

setTimeout(function() {
    var check_selected = $(".CollectionInner__Sidebar .CollectionFilters li.Linklist__Item").hasClass('is-selected');
    if(check_selected == true){
        var get_selected = $(".CollectionInner__Sidebar .CollectionFilters li.Linklist__Item.is-selected button").attr('data-tag');
        $(".custom_tags_inner .filter_trigger_custom").removeClass('active');
        $('.custom_tags_inner .filter_trigger_custom[data-value="' + get_selected + '"]').addClass('active');
    }
}, 2500);